var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/src/telemetry/constants.js
var require_constants = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/src/telemetry/constants.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TELEMETRY_CONFIG_MISSING_MSG = void 0;
    exports.TELEMETRY_CONFIG_MISSING_MSG = "[TangerineBox] Telemetry configuration is missing, events will not be emitted";
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/errors.js
var require_errors = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/errors.js"(exports) {
    "use strict";
    var __extends = exports && exports.__extends || /* @__PURE__ */ function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (Object.prototype.hasOwnProperty.call(b2, p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.RefreshCredentialError = exports.InvalidCredentialsError = exports.MetaTagParsingError = exports.TelemetryBrokerNotAvailableError = exports.FailureRequestError = exports.TerminalRequestError = exports.TangerineBoxError = void 0;
    var TangerineBoxError2 = (
      /** @class */
      function(_super) {
        __extends(TangerineBoxError3, _super);
        function TangerineBoxError3(message, originalError) {
          var _this = _super.call(this, message) || this;
          _this.message = message;
          _this.originalError = originalError;
          _this.name = _this.constructor.name;
          if (originalError) {
            _this.stack += "\nCaused by: " + originalError.stack;
          }
          return _this;
        }
        return TangerineBoxError3;
      }(Error)
    );
    exports.TangerineBoxError = TangerineBoxError2;
    var TerminalRequestError = (
      /** @class */
      function(_super) {
        __extends(TerminalRequestError2, _super);
        function TerminalRequestError2(message, metadata) {
          var _this = _super.call(this, message) || this;
          _this.message = message;
          _this.metadata = metadata;
          return _this;
        }
        return TerminalRequestError2;
      }(TangerineBoxError2)
    );
    exports.TerminalRequestError = TerminalRequestError;
    var FailureRequestError = (
      /** @class */
      function(_super) {
        __extends(FailureRequestError2, _super);
        function FailureRequestError2(message, metadata) {
          var _this = _super.call(this, message) || this;
          _this.message = message;
          _this.metadata = metadata;
          return _this;
        }
        return FailureRequestError2;
      }(TangerineBoxError2)
    );
    exports.FailureRequestError = FailureRequestError;
    var TelemetryBrokerNotAvailableError = (
      /** @class */
      function(_super) {
        __extends(TelemetryBrokerNotAvailableError2, _super);
        function TelemetryBrokerNotAvailableError2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        return TelemetryBrokerNotAvailableError2;
      }(TangerineBoxError2)
    );
    exports.TelemetryBrokerNotAvailableError = TelemetryBrokerNotAvailableError;
    var MetaTagParsingError2 = (
      /** @class */
      function(_super) {
        __extends(MetaTagParsingError3, _super);
        function MetaTagParsingError3() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        return MetaTagParsingError3;
      }(TangerineBoxError2)
    );
    exports.MetaTagParsingError = MetaTagParsingError2;
    var InvalidCredentialsError = (
      /** @class */
      function(_super) {
        __extends(InvalidCredentialsError2, _super);
        function InvalidCredentialsError2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        return InvalidCredentialsError2;
      }(TangerineBoxError2)
    );
    exports.InvalidCredentialsError = InvalidCredentialsError;
    var RefreshCredentialError = (
      /** @class */
      function(_super) {
        __extends(RefreshCredentialError2, _super);
        function RefreshCredentialError2() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        return RefreshCredentialError2;
      }(TangerineBoxError2)
    );
    exports.RefreshCredentialError = RefreshCredentialError;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/HttpClient.js
var require_HttpClient = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/HttpClient.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    var __awaiter = exports && exports.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __generator = exports && exports.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1)
          throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f)
          throw new TypeError("Generator is already executing.");
        while (_)
          try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
              return t;
            if (y = 0, t)
              op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return { value: op[1], done: false };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2])
                  _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HttpClient = exports.MAX_RETRIES = void 0;
    var errors_1 = require_errors();
    exports.MAX_RETRIES = 4;
    var calculateSleepTime = function(retries) {
      return Math.random() * Math.min(10, Math.pow(2, retries)) * 100;
    };
    var isRetryable = function(httpStatusCode) {
      return httpStatusCode >= 500 || httpStatusCode === 429;
    };
    var HttpClient = (
      /** @class */
      function() {
        function HttpClient2(jsonReplacer) {
          this.jsonReplacer = jsonReplacer;
        }
        HttpClient2.prototype.call = function(request) {
          var _a, _b, _c;
          return __awaiter(this, void 0, void 0, function() {
            var startTimestamp, retries, response, error_1;
            return __generator(this, function(_d) {
              switch (_d.label) {
                case 0:
                  startTimestamp = /* @__PURE__ */ new Date();
                  retries = 0;
                  _d.label = 1;
                case 1:
                  if (!(retries <= ((_a = request.maxRetries) !== null && _a !== void 0 ? _a : exports.MAX_RETRIES)))
                    return [3, 6];
                  if (retries) {
                    calculateSleepTime(retries);
                  }
                  _d.label = 2;
                case 2:
                  _d.trys.push([2, 4, , 5]);
                  return [4, this.callWithFetch(request, retries)];
                case 3:
                  response = _d.sent();
                  if (!isRetryable(response.status)) {
                    return [2, {
                      finalHttpStatusCode: response.status,
                      data: response.data,
                      retries,
                      startTimestamp,
                      latencyMillseconds: (/* @__PURE__ */ new Date()).getTime() - startTimestamp.getTime(),
                      maxRetriesExceeded: false
                    }];
                  }
                  return [3, 5];
                case 4:
                  error_1 = _d.sent();
                  if (retries >= ((_b = request.maxRetries) !== null && _b !== void 0 ? _b : exports.MAX_RETRIES) && error_1 instanceof Error) {
                    throw new errors_1.TerminalRequestError(error_1.message, {
                      finalHttpStatusCode: 500,
                      retries,
                      code: error_1.metadata.code,
                      startTimestamp,
                      latencyMillseconds: (/* @__PURE__ */ new Date()).getTime() - startTimestamp.getTime(),
                      maxRetriesExceeded: true
                    });
                  }
                  return [3, 5];
                case 5:
                  retries++;
                  return [3, 1];
                case 6:
                  throw new errors_1.TerminalRequestError("Too many retries", {
                    finalHttpStatusCode: 500,
                    retries: (_c = request.maxRetries) !== null && _c !== void 0 ? _c : exports.MAX_RETRIES,
                    startTimestamp,
                    code: "MaxRetriesExceeded",
                    latencyMillseconds: (/* @__PURE__ */ new Date()).getTime() - startTimestamp.getTime(),
                    maxRetriesExceeded: true
                  });
              }
            });
          });
        };
        HttpClient2.prototype.callWithFetch = function(requestAttributes, retries) {
          var _a;
          return __awaiter(this, void 0, void 0, function() {
            var requestOptions, controller_1, response, contentType, json, text, err_1;
            return __generator(this, function(_b) {
              switch (_b.label) {
                case 0:
                  requestOptions = {
                    method: requestAttributes.method,
                    headers: __assign({ "X-Retries": "".concat(retries) }, requestAttributes.headers),
                    keepalive: true
                  };
                  if (requestAttributes.timeout !== void 0 && requestAttributes.timeout > 0) {
                    controller_1 = new AbortController();
                    setTimeout(function() {
                      return controller_1.abort();
                    }, requestAttributes.timeout + retries * (requestAttributes.timeoutIncreasePerRetry || 0));
                    requestOptions.signal = controller_1.signal;
                  }
                  if (requestAttributes.method.toUpperCase() !== "GET") {
                    requestOptions.body = this.createBody(requestAttributes);
                  }
                  _b.label = 1;
                case 1:
                  _b.trys.push([1, 7, , 8]);
                  return [4, fetch(requestAttributes.url, requestOptions)];
                case 2:
                  response = _b.sent();
                  contentType = (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get("Content-Type");
                  if (!(contentType && /application\/json/.test(contentType)))
                    return [3, 4];
                  return [4, response.json()];
                case 3:
                  json = _b.sent();
                  return [2, {
                    data: json,
                    retries,
                    status: response.status
                  }];
                case 4:
                  return [4, response.text()];
                case 5:
                  text = _b.sent();
                  return [2, {
                    data: text,
                    retries,
                    status: response.status
                  }];
                case 6:
                  return [3, 8];
                case 7:
                  err_1 = _b.sent();
                  if (err_1 instanceof Error && err_1.name === "AbortError") {
                    throw new errors_1.FailureRequestError("Request timeout", {
                      code: "RequestTimeout",
                      finalHttpStatusCode: 500,
                      retries
                    });
                  } else {
                    throw new errors_1.FailureRequestError("Request encountered an error", {
                      code: "RequestFailed",
                      finalHttpStatusCode: 500,
                      retries
                    });
                  }
                  return [3, 8];
                case 8:
                  return [
                    2
                    /*return*/
                  ];
              }
            });
          });
        };
        HttpClient2.prototype.createBody = function(requestAttributes) {
          var data = requestAttributes.data;
          if (!data) {
            return null;
          }
          if (typeof data === "string") {
            return data;
          }
          if (typeof data === "object") {
            return JSON.stringify(data, this.jsonReplacer);
          }
          return String(data);
        };
        return HttpClient2;
      }()
    );
    exports.HttpClient = HttpClient;
  }
});

// node_modules/@amzn/tangerinebox-telemetry-interfaces/lib/src/TelemetryBrokerInterface.js
var require_TelemetryBrokerInterface = __commonJS({
  "node_modules/@amzn/tangerinebox-telemetry-interfaces/lib/src/TelemetryBrokerInterface.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TELEMETRY_BROKER_PROPERTY_NAME = void 0;
    exports.TELEMETRY_BROKER_PROPERTY_NAME = "_internal_tb_telemetry_broker";
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/DataParser.js
var require_DataParser = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/DataParser.js"(exports) {
    "use strict";
    var __awaiter = exports && exports.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __generator = exports && exports.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1)
          throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f)
          throw new TypeError("Generator is already executing.");
        while (_)
          try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
              return t;
            if (y = 0, t)
              op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return { value: op[1], done: false };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2])
                  _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DataParser = void 0;
    var errors_1 = require_errors();
    var TelemetryBrokerInterface_1 = require_TelemetryBrokerInterface();
    var USER_INFO_COOKIE = "aws-userInfo";
    var SESSION_CONTEXT_NAME_ATTRIBUTE = "awsc-session-data";
    var SESSION_ID_COOKIE_PREFIX = "__Secure-aws-session-id";
    var sessionIdCookie = function(sessionDifferentiator) {
      return "".concat(SESSION_ID_COOKIE_PREFIX, "-").concat(sessionDifferentiator);
    };
    var DataParser = (
      /** @class */
      function() {
        function DataParser2(metaTagContent) {
          this.windowWithTelemetryBroker = this.findWindowWithTelemetryBroker();
          this.metaTagContentCache = metaTagContent;
          this.sessionDataCache = this.parseSessionDataMetaTag(this.windowWithTelemetryBroker);
        }
        DataParser2.getInstance = function(metaTagContent) {
          if (!this.metaDataProviderInstance) {
            this.metaDataProviderInstance = new DataParser2(metaTagContent);
          }
          return this.metaDataProviderInstance;
        };
        DataParser2.prototype.getTelemetryBrokerWindow = function() {
          return this.windowWithTelemetryBroker;
        };
        DataParser2.prototype.getMetaTagContent = function() {
          if (!this.metaTagContentCache) {
            this.metaTagContentCache = this.parseTangerineBoxMetaTag();
          }
          return this.metaTagContentCache;
        };
        DataParser2.prototype.getTelemetryMetaTagContent = function() {
          if (!this.telemetryMetaTagContentCache) {
            this.telemetryMetaTagContentCache = this.parseTangerineBoxTelemetryMetaTag();
          }
          return this.telemetryMetaTagContentCache;
        };
        DataParser2.prototype.getCredentialsConfig = function() {
          return {
            browserCredsFullPath: this.getMetaTagContent().browserCredsFullPath,
            csrfToken: this.getMetaTagContent().csrfToken
          };
        };
        DataParser2.prototype.parseTangerineBoxMetaTag = function() {
          var element = this.parseMetaTag("tb-data");
          if (!element) {
            throw new errors_1.MetaTagParsingError("TangerineBox meta tag not found");
          }
          try {
            return JSON.parse(element);
          } catch (error) {
            throw new errors_1.MetaTagParsingError("Unable to parse TangerineBox meta tag contents", error instanceof Error ? error : new Error(String(error)));
          }
        };
        DataParser2.prototype.parseTangerineBoxTelemetryMetaTag = function() {
          var element = this.parseMetaTag("tbt-data");
          if (!element) {
            throw new errors_1.MetaTagParsingError("TangerineBox Telemetry meta tag not found");
          }
          try {
            return JSON.parse(element);
          } catch (error) {
            throw new errors_1.MetaTagParsingError("Unable to parse TangerineBox Telemetry meta tag contents", error instanceof Error ? error : new Error(String(error)));
          }
        };
        DataParser2.prototype.parseMetaTag = function(metaTagName, windowObject) {
          var documentObject = windowObject ? windowObject.document : document;
          var element = documentObject.querySelector("meta[name='".concat(metaTagName, "']"));
          if (!element) {
            return void 0;
          }
          return element.content;
        };
        DataParser2.prototype.parseCookie = function(cookieName, cookieString) {
          if (cookieString === void 0) {
            cookieString = document.cookie;
          }
          var cookie = cookieString.match("".concat(cookieName, "=([^;]*)"));
          if (!cookie || !cookie[1]) {
            return void 0;
          }
          return cookie[1];
        };
        DataParser2.prototype.triggerLoggedOutDialog = function() {
          var isUsingNav2 = this.parseMetaTag("awsc-widget-nav") !== void 0 || this.parseMetaTag("awsc-widget-next") !== void 0;
          if (typeof window !== "undefined") {
            if (isUsingNav2) {
              window.dispatchEvent(this.createCustomEvent("auth-change-detected"));
            } else {
              if (window.AWSC && typeof window.AWSC.jQuery === "function") {
                window.AWSC.jQuery(window.AWSC).trigger("auth-change-detected");
              }
            }
          }
        };
        DataParser2.prototype.createCustomEvent = function(name) {
          if (typeof window !== "undefined" && typeof window.CustomEvent === "function") {
            return new CustomEvent(name);
          } else {
            var params = {
              bubbles: false,
              cancelable: false,
              detail: null
            };
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(name, params.bubbles, params.cancelable, params.detail);
            return evt;
          }
        };
        DataParser2.prototype.parseSessionDataMetaTag = function(windowObject) {
          var element = this.parseMetaTag(SESSION_CONTEXT_NAME_ATTRIBUTE, windowObject);
          if (!element) {
            throw new errors_1.MetaTagParsingError("Session data meta tag not found");
          }
          try {
            return JSON.parse(element);
          } catch (error) {
            throw new errors_1.MetaTagParsingError("Unable to parse session data meta tag content", error instanceof Error ? error : new Error(String(error)));
          }
        };
        DataParser2.prototype.getSessionDataValue = function(attribute) {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.sessionDataCache[attribute]];
            });
          });
        };
        DataParser2.prototype.getLogoutDetectionCookieName = function() {
          if (this.isPrismModeEnabled()) {
            if (!this.sessionDataCache.sessionDifferentiator) {
              throw new errors_1.MetaTagParsingError("sessionDifferentiator is not found in prism mode");
            }
            return sessionIdCookie(this.sessionDataCache.sessionDifferentiator);
          }
          return USER_INFO_COOKIE;
        };
        DataParser2.prototype.isPrismModeEnabled = function() {
          var prismModeEnabled = this.getMetaTagContent().prismModeEnabled;
          if (typeof prismModeEnabled === "boolean") {
            return prismModeEnabled;
          }
          return !!this.sessionDataCache.prismModeEnabled;
        };
        DataParser2.prototype.findWindowWithTelemetryBroker = function() {
          var currentWindow = window;
          while (true) {
            if (currentWindow[TelemetryBrokerInterface_1.TELEMETRY_BROKER_PROPERTY_NAME]) {
              return currentWindow;
            }
            if (currentWindow === currentWindow.parent) {
              return void 0;
            }
            currentWindow = currentWindow.parent;
          }
        };
        return DataParser2;
      }()
    );
    exports.DataParser = DataParser;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/CookieObserver.js
var require_CookieObserver = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/CookieObserver.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CookieObserver = void 0;
    var DataParser_1 = require_DataParser();
    var POLLING_INTERVAL_MS = 5e3;
    var CookieObserver = (
      /** @class */
      function() {
        function CookieObserver2(cookieName, pollingInterval, dataParser) {
          if (pollingInterval === void 0) {
            pollingInterval = POLLING_INTERVAL_MS;
          }
          this.cookieName = cookieName;
          this.listeners = [];
          this.dataParser = dataParser !== null && dataParser !== void 0 ? dataParser : DataParser_1.DataParser.getInstance();
          this.lastSeenCookieValue = this.dataParser.parseCookie(cookieName);
          setInterval(this.poll.bind(this), pollingInterval);
        }
        CookieObserver2.prototype.addChangeListener = function(listener) {
          this.listeners.push(listener);
        };
        CookieObserver2.prototype.poll = function() {
          var currentValue = this.dataParser.parseCookie(this.cookieName);
          if (this.lastSeenCookieValue !== currentValue) {
            this.getCookieListener().forEach(function(listener) {
              return listener();
            });
          }
          this.lastSeenCookieValue = currentValue;
        };
        CookieObserver2.prototype.getCookieListener = function() {
          return this.listeners;
        };
        return CookieObserver2;
      }()
    );
    exports.CookieObserver = CookieObserver;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/telemetry/BrokerWrapper.js
var require_BrokerWrapper = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/telemetry/BrokerWrapper.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BrokerWrapper = void 0;
    var TelemetryBrokerInterface_1 = require_TelemetryBrokerInterface();
    var BrokerWrapper = (
      /** @class */
      function() {
        function BrokerWrapper2(windowObject) {
          this.telemetryBroker = windowObject[TelemetryBrokerInterface_1.TELEMETRY_BROKER_PROPERTY_NAME];
        }
        BrokerWrapper2.prototype.register = function(props) {
          return this.telemetryBroker.register(props);
        };
        BrokerWrapper2.prototype.addEvent = function(props) {
          this.telemetryBroker.addEvent(props);
        };
        BrokerWrapper2.prototype.dangerouslyFlushEvents = function() {
          this.telemetryBroker.dangerouslyFlushEvents();
        };
        return BrokerWrapper2;
      }()
    );
    exports.BrokerWrapper = BrokerWrapper;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/packageVersion.js
var require_packageVersion = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/packageVersion.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PACKAGE_VERSION = void 0;
    exports.PACKAGE_VERSION = "2.0.78765.0#10717a43";
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/telemetry/ScheduledEventTracker.js
var require_ScheduledEventTracker = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/telemetry/ScheduledEventTracker.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ScheduledEventTracker = void 0;
    var DataParser_1 = require_DataParser();
    var BrokerWrapper_1 = require_BrokerWrapper();
    var packageVersion_1 = require_packageVersion();
    var errors_1 = require_errors();
    var ScheduledEventTracker = (
      /** @class */
      function() {
        function ScheduledEventTracker2(props, trackerProps) {
          this.props = props;
          var telemetryTokensForPublicEvents = function() {
            var tokensForPublicEvents = trackerProps.tokensForPublicEvents;
            if (tokensForPublicEvents !== void 0) {
              return tokensForPublicEvents;
            }
            var parentToken = trackerProps.parentToken;
            if (parentToken !== void 0) {
              return [parentToken];
            }
            return void 0;
          }();
          this.id = this.props.broker.register({
            source: "weblib-v2",
            telemetryToken: trackerProps.token,
            telemetryTokensForPublicEvents
          });
        }
        ScheduledEventTracker2.getInstance = function(trackerProps) {
          var props = trackerProps !== null && trackerProps !== void 0 ? trackerProps : {
            token: DataParser_1.DataParser.getInstance().getTelemetryMetaTagContent().telemetryToken
          };
          var windowWithTelemetryBroker = DataParser_1.DataParser.getInstance().getTelemetryBrokerWindow();
          if (windowWithTelemetryBroker === void 0) {
            throw new errors_1.TelemetryBrokerNotAvailableError("Telemetry broker not found");
          }
          return new ScheduledEventTracker2({
            broker: new BrokerWrapper_1.BrokerWrapper(windowWithTelemetryBroker)
          }, props);
        };
        ScheduledEventTracker2.prototype.addEvent = function(content, options) {
          var event = {
            type: "log",
            content,
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event }, options));
        };
        ScheduledEventTracker2.prototype.addError = function(error, content, options) {
          var event = {
            type: "error",
            content: __assign({ error }, content),
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event }, options));
        };
        ScheduledEventTracker2.prototype.addFatalError = function(error, content, metadata, options) {
          var event = {
            type: "fatal-error",
            content: __assign({ error }, content),
            fatalErrorMetadata: metadata,
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event }, options));
        };
        ScheduledEventTracker2.prototype.addAwsSdkEvent = function(content, options) {
          var event = {
            type: "aws-sdk-metric",
            awsSdkMetric: content,
            content: {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event }, options));
        };
        ScheduledEventTracker2.prototype.addFmsEvaluationEvent = function(event, content, options) {
          var trackerEvent = {
            type: "fms-evaluation",
            fmsEvaluation: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addAwsArachnidQueryEvent = function(event, content, options) {
          var trackerEvent = {
            type: "aws-arachnid-query",
            awsArachnidQuery: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addJanusApiEvent = function(event, content, options) {
          var trackerEvent = {
            type: "janus-api",
            janusApi: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addJanusCredentialEvent = function(event, content, options) {
          var trackerEvent = {
            type: "janus-credential",
            janusCredential: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addLotusCspEvent = function(event, content, options) {
          var trackerEvent = {
            type: "lotus-csp",
            lotusCsp: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addLotusIsolatedIFrameEvent = function(event, content, options) {
          var trackerEvent = {
            type: "lotus-isolated-iframe",
            lotusIsolatedIFrame: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addLotusImportPackageEvent = function(event, content, options) {
          var trackerEvent = {
            type: "lotus-import-package",
            lotusImportPackage: event.lotusImportPackage,
            lotusMetadata: event.lotusMetadata,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addModuleLifecycleEvent = function(event, content, options) {
          var trackerEvent = {
            type: "module-lifecycle",
            moduleLifecycle: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addCloudEditorEvent = function(event, content, options) {
          var trackerEvent = {
            type: "cloud-editor",
            cloudEditor: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addCloudEditorLspEvent = function(event, content, options) {
          var trackerEvent = {
            type: "cloud-editor-lsp",
            cloudEditorLsp: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addPapiProxyEvent = function(event, content, options) {
          var trackerEvent = {
            type: "papi-proxy",
            papiProxy: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addPapiCredentialEvent = function(event, content, options) {
          var trackerEvent = {
            type: "papi-credential",
            papiCredential: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.addBootstrapEvent = function(event, content, options) {
          var trackerEvent = {
            type: "tb-bootstrap",
            tbBootstrap: event,
            content: content !== null && content !== void 0 ? content : {},
            version: packageVersion_1.PACKAGE_VERSION,
            timestamp: /* @__PURE__ */ new Date()
          };
          this.props.broker.addEvent(__assign({ tenantId: this.id, event: trackerEvent }, options));
        };
        ScheduledEventTracker2.prototype.dangerouslyFlushEvents = function() {
          this.props.broker.dangerouslyFlushEvents();
        };
        return ScheduledEventTracker2;
      }()
    );
    exports.ScheduledEventTracker = ScheduledEventTracker;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/BrowserCredentials.js
var require_BrowserCredentials = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/BrowserCredentials.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    var __awaiter = exports && exports.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __generator = exports && exports.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1)
          throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f)
          throw new TypeError("Generator is already executing.");
        while (_)
          try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
              return t;
            if (y = 0, t)
              op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return { value: op[1], done: false };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2])
                  _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BrowserCredentials = void 0;
    var HttpClient_1 = require_HttpClient();
    var CookieObserver_1 = require_CookieObserver();
    var errors_1 = require_errors();
    var DataParser_1 = require_DataParser();
    var ScheduledEventTracker_1 = require_ScheduledEventTracker();
    var credentialsCache;
    var BrowserCredentials = (
      /** @class */
      function() {
        function BrowserCredentials2(credentialsConfig, httpClient, eventTracker, cookieObserver, dataParser) {
          var _this = this;
          this.isLoggedOut = false;
          this.loggedOutMessage = "User Logged Out";
          this.dataParser = dataParser;
          this.credentialsConfig = credentialsConfig;
          this.eventTracker = eventTracker;
          this.httpClient = httpClient;
          this.cookieObserver = cookieObserver;
          this.addLogoutListener(function() {
            _this.isLoggedOut = true;
            if (credentialsCache) {
              credentialsCache.accessKeyId = "";
              credentialsCache.secretAccessKey = "";
              credentialsCache.sessionToken = "";
              credentialsCache.expiration = /* @__PURE__ */ new Date(0);
            }
          });
        }
        BrowserCredentials2.getInstance = function() {
          if (!this.browserCredentialsInstance) {
            var dataParser = DataParser_1.DataParser.getInstance();
            var eventTracker = void 0;
            try {
              eventTracker = ScheduledEventTracker_1.ScheduledEventTracker.getInstance();
            } catch (err) {
              console.error("BrowserCredentials cannot instantiate ScheduledEventTracker", err);
            }
            var browserCredentialsConfig = dataParser.getCredentialsConfig();
            var httpClient = new HttpClient_1.HttpClient();
            this.browserCredentialsInstance = new BrowserCredentials2(browserCredentialsConfig, httpClient, eventTracker, new CookieObserver_1.CookieObserver(dataParser.getLogoutDetectionCookieName()), dataParser);
          }
          return this.browserCredentialsInstance;
        };
        BrowserCredentials2.prototype.getCredentials = function() {
          return __awaiter(this, void 0, void 0, function() {
            var request, res, e_1, errorMessage, error;
            return __generator(this, function(_a) {
              switch (_a.label) {
                case 0:
                  if (this.isLoggedOut) {
                    throw new errors_1.RefreshCredentialError(this.loggedOutMessage);
                  }
                  if ((credentialsCache === null || credentialsCache === void 0 ? void 0 : credentialsCache.expiration) && new Date(credentialsCache.expiration).getTime() - Date.now() > 3e5) {
                    return [2, credentialsCache];
                  }
                  request = {
                    url: this.credentialsConfig.browserCredsFullPath,
                    method: "POST",
                    headers: {
                      "x-csrf-token": this.credentialsConfig.csrfToken
                    },
                    timeout: 5e3,
                    timeoutIncreasePerRetry: 5e3,
                    maxRetries: 4
                  };
                  _a.label = 1;
                case 1:
                  _a.trys.push([1, 3, , 4]);
                  return [4, this.httpClient.call(request)];
                case 2:
                  res = _a.sent();
                  return [3, 4];
                case 3:
                  e_1 = _a.sent();
                  this.emitClientErrorEvent(e_1);
                  throw new errors_1.RefreshCredentialError("Fail to request credentials", e_1);
                case 4:
                  this.emitClientResponseEvent(res);
                  if (res.finalHttpStatusCode >= 200 && res.finalHttpStatusCode < 300) {
                    this.validate(res.data);
                  } else {
                    if ([401, 403].includes(res.finalHttpStatusCode)) {
                      errorMessage = res.finalHttpStatusCode === 401 ? "Unauthorized" : "InvalidCsrfTokenError";
                      this.dataParser.triggerLoggedOutDialog();
                      this.cookieObserver.getCookieListener().forEach(function(listener) {
                        return listener();
                      });
                      this.loggedOutMessage = "".concat(errorMessage, ": Session is invalid");
                      throw new errors_1.RefreshCredentialError(this.loggedOutMessage);
                    }
                    error = void 0;
                    try {
                      error = JSON.parse(res.data.toString()).error;
                    } catch (err) {
                      error = "HTTP status code ".concat(res.finalHttpStatusCode);
                    }
                    throw new errors_1.RefreshCredentialError(error);
                  }
                  credentialsCache = res.data;
                  return [2, credentialsCache];
              }
            });
          });
        };
        BrowserCredentials2.prototype.validate = function(credentials) {
          for (var _i = 0, _a = [
            "accessKeyId",
            "secretAccessKey",
            "sessionToken"
          ]; _i < _a.length; _i++) {
            var property = _a[_i];
            if (!credentials[property]) {
              throw new errors_1.InvalidCredentialsError('Invalid credentials, missing property: "'.concat(property, '"'));
            }
          }
        };
        BrowserCredentials2.prototype.addLogoutListener = function(listener) {
          this.cookieObserver.addChangeListener(listener);
        };
        BrowserCredentials2.prototype.emitClientErrorEvent = function(err) {
          var _a;
          var event = {
            attemptCount: err.metadata.retries,
            latencyMillseconds: err.metadata.latencyMillseconds,
            maxRetriesExceeded: err.metadata.maxRetriesExceeded,
            startTimestamp: err.metadata.startTimestamp,
            finalSdkException: err.metadata.code,
            finalSdkExceptionMessage: err.message,
            operation: "RefreshCredentials",
            service: "TangerineBox",
            region: ""
          };
          (_a = this.eventTracker) === null || _a === void 0 ? void 0 : _a.addAwsSdkEvent(event);
        };
        BrowserCredentials2.prototype.emitClientResponseEvent = function(res) {
          var _a;
          var event = {
            attemptCount: res.retries,
            finalHttpStatusCode: res.finalHttpStatusCode,
            latencyMillseconds: res.latencyMillseconds,
            maxRetriesExceeded: res.maxRetriesExceeded,
            startTimestamp: res.startTimestamp,
            operation: "RefreshCredentials",
            service: "TangerineBox",
            region: ""
          };
          if (res.finalHttpStatusCode >= 400) {
            event = __assign({ finalSdkException: "RequestFailed", finalSdkExceptionMessage: "Request failed with status code ".concat(res.finalHttpStatusCode), finalHttpStatusCode: res.finalHttpStatusCode }, event);
          }
          (_a = this.eventTracker) === null || _a === void 0 ? void 0 : _a.addAwsSdkEvent(event);
        };
        return BrowserCredentials2;
      }()
    );
    exports.BrowserCredentials = BrowserCredentials;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/rip.json
var require_rip = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/rip.json"(exports, module) {
    module.exports = {
      "ap-southeast-6": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-isof-south-1": {
        websiteDomain: "csphome.hci.ic.gov",
        websiteDomainDualstack: "awshome.hci.ic.gov"
      },
      "us-iso-west-1": {
        websiteDomain: "c2shome.ic.gov",
        websiteDomainDualstack: "awshome.ic.gov"
      },
      "eu-north-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "me-south-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "cn-north-1": {
        websiteDomain: "amazonaws.cn",
        websiteDomainDualstack: "amazonwebservices.cn"
      },
      "ap-southeast-7": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-south-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "eu-west-3": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-southeast-3": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-east-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "af-south-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-iso-east-1": {
        websiteDomain: "c2shome.ic.gov",
        websiteDomainDualstack: "awshome.ic.gov"
      },
      "eu-west-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "me-central-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-isob-west-1": {
        websiteDomain: "sc2shome.sgov.gov",
        websiteDomainDualstack: "awshome.scloud"
      },
      "eu-central-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "sa-east-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-east-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-south-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-east-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-northeast-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-northeast-3": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-southeast-5": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-isob-east-1": {
        websiteDomain: "sc2shome.sgov.gov",
        websiteDomainDualstack: "awshome.scloud"
      },
      "eu-west-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-isof-east-1": {
        websiteDomain: "csphome.hci.ic.gov",
        websiteDomainDualstack: "awshome.hci.ic.gov"
      },
      "us-northeast-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-southeast-4": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "eu-south-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "eu-isoe-west-1": {
        websiteDomain: "csphome.adc-e.uk",
        websiteDomainDualstack: "awshome.adc-e.uk"
      },
      "ap-northeast-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-gov-east-1": {
        websiteDomain: "amazonaws-us-gov.com",
        websiteDomainDualstack: "aws-us-gov.com"
      },
      "us-gov-west-1": {
        websiteDomain: "amazonaws-us-gov.com",
        websiteDomainDualstack: "aws-us-gov.com"
      },
      "us-west-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "mx-central-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "me-west-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "us-west-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-southeast-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-southeast-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "eusc-de-east-1": {
        websiteDomain: "amazonaws-eusc.eu",
        websiteDomainDualstack: "aws.eu"
      },
      "il-central-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ap-east-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ca-central-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "ca-west-1": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "eu-south-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      },
      "cn-northwest-1": {
        websiteDomain: "amazonaws.cn",
        websiteDomainDualstack: "amazonwebservices.cn"
      },
      "eu-central-2": {
        websiteDomain: "aws.amazon.com",
        websiteDomainDualstack: "aws.com"
      }
    };
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/RipRegionData.js
var require_RipRegionData = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/internal/RipRegionData.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ripRegion = void 0;
    var ripData = require_rip();
    function ripRegion(region) {
      return ripData[region];
    }
    exports.ripRegion = ripRegion;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/src/MetaDataProvider.js
var require_MetaDataProvider = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/src/MetaDataProvider.js"(exports) {
    "use strict";
    var __awaiter = exports && exports.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __generator = exports && exports.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1)
          throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f)
          throw new TypeError("Generator is already executing.");
        while (_)
          try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
              return t;
            if (y = 0, t)
              op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return { value: op[1], done: false };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2])
                  _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MetaDataProvider = void 0;
    var DataParser_1 = require_DataParser();
    var RipRegionData_1 = require_RipRegionData();
    var MetaDataProvider = (
      /** @class */
      function() {
        function MetaDataProvider2(dataParser) {
          this.dataParser = dataParser;
        }
        MetaDataProvider2.getInstance = function() {
          if (!this.metaDataProviderInstance) {
            this.metaDataProviderInstance = new MetaDataProvider2(DataParser_1.DataParser.getInstance());
          }
          return this.metaDataProviderInstance;
        };
        MetaDataProvider2.prototype.getCdnUrl = function(assetId) {
          if (/^(http|https|ws|wss):\/\//.test(assetId)) {
            return assetId;
          }
          return "".concat(this.dataParser.getMetaTagContent().cdn).concat(assetId);
        };
        MetaDataProvider2.prototype.getCustomContext = function(key) {
          return this.dataParser.getMetaTagContent().custom[key];
        };
        MetaDataProvider2.prototype.getAssetUrl = function(key, assetPath) {
          var assetMainPath = this.getCustomContext(key) + "/".concat(assetPath);
          return this.getCdnUrl(assetMainPath);
        };
        MetaDataProvider2.prototype.getConsoleTelemetryToken = function() {
          return this.dataParser.getTelemetryMetaTagContent().telemetryToken;
        };
        MetaDataProvider2.prototype.getSessionARN = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("sessionARN")];
            });
          });
        };
        MetaDataProvider2.prototype.getAccountId = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("accountId")];
            });
          });
        };
        MetaDataProvider2.prototype.getIdentityToken = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("identityToken")];
            });
          });
        };
        MetaDataProvider2.prototype.getSessionId = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("sessionId")];
            });
          });
        };
        MetaDataProvider2.prototype.getInfrastructureRegion = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("infrastructureRegion")];
            });
          });
        };
        MetaDataProvider2.prototype.getVpc = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("vpc")];
            });
          });
        };
        MetaDataProvider2.prototype.getAccountAlias = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("accountAlias")];
            });
          });
        };
        MetaDataProvider2.prototype.getDisplayName = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("displayName")];
            });
          });
        };
        MetaDataProvider2.prototype.getSessionDifferentiator = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              return [2, this.dataParser.getSessionDataValue("sessionDifferentiator")];
            });
          });
        };
        MetaDataProvider2.prototype.isMultiSessionEnabled = function() {
          return __awaiter(this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              switch (_a.label) {
                case 0:
                  return [4, this.dataParser.getSessionDataValue("prismModeEnabled")];
                case 1:
                  return [2, !!_a.sent()];
              }
            });
          });
        };
        MetaDataProvider2.prototype.getCustomServiceEndpoint = function(key) {
          var endpoints = this.dataParser.getMetaTagContent().endpoints;
          return endpoints ? endpoints["CUSTOM_".concat(key)] : void 0;
        };
        MetaDataProvider2.prototype.getIamAdminStandardConfig = function() {
          var endpoints = this.dataParser.getMetaTagContent().endpoints || {};
          var iamAdminEndpoint = endpoints.STANDARD_iamadmin;
          var signingRegion = this.getCustomContext("STANDARD_iamadmin_signing_region");
          if (!iamAdminEndpoint || !signingRegion) {
            return void 0;
          }
          return {
            region: signingRegion,
            endpoint: iamAdminEndpoint
          };
        };
        MetaDataProvider2.prototype.getHelpPanelApiEndpoint = function() {
          var endpoints = this.dataParser.getMetaTagContent().endpoints || {};
          return endpoints.STANDARD_HelpPanelAPI;
        };
        MetaDataProvider2.prototype.getUserPreferenceServiceEndpoint = function() {
          return __awaiter(this, void 0, void 0, function() {
            var dualstackEnabledDomain, region, regionConfig, websiteDomain;
            return __generator(this, function(_a) {
              switch (_a.label) {
                case 0:
                  return [4, this.dataParser.getSessionDataValue("dualstackEnabledDomain")];
                case 1:
                  dualstackEnabledDomain = _a.sent();
                  return [4, this.getInfrastructureRegion()];
                case 2:
                  region = _a.sent();
                  regionConfig = (0, RipRegionData_1.ripRegion)(region);
                  websiteDomain = dualstackEnabledDomain ? regionConfig.websiteDomainDualstack : regionConfig.websiteDomain;
                  return [2, "https://".concat(region, ".console.").concat(websiteDomain, "/p/pref/1")];
              }
            });
          });
        };
        return MetaDataProvider2;
      }()
    );
    exports.MetaDataProvider = MetaDataProvider;
  }
});

// node_modules/@amzn/tangerinebox-weblib-core/dist/index.js
var require_dist = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-core/dist/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MetaDataProvider = exports.ScheduledEventTracker = exports.BrowserCredentials = void 0;
    var BrowserCredentials_1 = require_BrowserCredentials();
    Object.defineProperty(exports, "BrowserCredentials", { enumerable: true, get: function() {
      return BrowserCredentials_1.BrowserCredentials;
    } });
    var ScheduledEventTracker_1 = require_ScheduledEventTracker();
    Object.defineProperty(exports, "ScheduledEventTracker", { enumerable: true, get: function() {
      return ScheduledEventTracker_1.ScheduledEventTracker;
    } });
    var MetaDataProvider_1 = require_MetaDataProvider();
    Object.defineProperty(exports, "MetaDataProvider", { enumerable: true, get: function() {
      return MetaDataProvider_1.MetaDataProvider;
    } });
  }
});

// node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/src/telemetry/TangerineBoxEventTrackerForLibrary.js
var require_TangerineBoxEventTrackerForLibrary = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/src/telemetry/TangerineBoxEventTrackerForLibrary.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NoOpTrackerForLibrary = exports.TangerineBoxEventTrackerForLibrary = void 0;
    var constants_1 = require_constants();
    var tangerinebox_weblib_core_1 = require_dist();
    var TangerineBoxEventTrackerForLibrary3 = (
      /** @class */
      function() {
        function TangerineBoxEventTrackerForLibrary4(scheduledEventTracker) {
          this.scheduledEventTracker = scheduledEventTracker;
        }
        TangerineBoxEventTrackerForLibrary4.getInstance = function(trackerProps) {
          try {
            return new TangerineBoxEventTrackerForLibrary4(tangerinebox_weblib_core_1.ScheduledEventTracker.getInstance(trackerProps));
          } catch (err) {
            console.warn(constants_1.TELEMETRY_CONFIG_MISSING_MSG);
            return new NoOpTrackerForLibrary();
          }
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addEvent = function(content) {
          this.scheduledEventTracker.addEvent(content, {
            // Disable library sending public events
            publicEvent: false
          });
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addError = function(error, content, options) {
          this.scheduledEventTracker.addError(error, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addFatalError = function(error, content, metadata, options) {
          this.scheduledEventTracker.addFatalError(error, content, metadata, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addFmsEvaluationEvent = function(event, content, options) {
          this.scheduledEventTracker.addFmsEvaluationEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addAwsArachnidQueryEvent = function(event, content, options) {
          this.scheduledEventTracker.addAwsArachnidQueryEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addJanusApiEvent = function(event, content, options) {
          this.scheduledEventTracker.addJanusApiEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addJanusCredentialEvent = function(event, content, options) {
          this.scheduledEventTracker.addJanusCredentialEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addLotusCspEvent = function(event, content, options) {
          this.scheduledEventTracker.addLotusCspEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addLotusIsolatedIFrameEvent = function(event, content, options) {
          this.scheduledEventTracker.addLotusIsolatedIFrameEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addLotusImportPackageEvent = function(event, content, options) {
          this.scheduledEventTracker.addLotusImportPackageEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addModuleLifecycleEvent = function(event, content, options) {
          this.scheduledEventTracker.addModuleLifecycleEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addCloudEditorEvent = function(event, content, options) {
          this.scheduledEventTracker.addCloudEditorEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addCloudEditorLspEvent = function(event, content, options) {
          this.scheduledEventTracker.addCloudEditorLspEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addPapiProxyEvent = function(event, content, options) {
          this.scheduledEventTracker.addPapiProxyEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addPapiCredentialEvent = function(event, content, options) {
          this.scheduledEventTracker.addPapiCredentialEvent(event, content, options);
        };
        TangerineBoxEventTrackerForLibrary4.prototype.addBootstrapEvent = function(event, content, options) {
          this.scheduledEventTracker.addBootstrapEvent(event, content, options);
        };
        return TangerineBoxEventTrackerForLibrary4;
      }()
    );
    exports.TangerineBoxEventTrackerForLibrary = TangerineBoxEventTrackerForLibrary3;
    var NoOpTrackerForLibrary = (
      /** @class */
      function() {
        function NoOpTrackerForLibrary2() {
        }
        NoOpTrackerForLibrary2.prototype.addEvent = function(_content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addError = function(_error, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addFatalError = function(_error, _content, _metadata, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addFmsEvaluationEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addAwsArachnidQueryEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addJanusApiEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addJanusCredentialEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addLotusCspEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addLotusIsolatedIFrameEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addLotusImportPackageEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addModuleLifecycleEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addCloudEditorEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addCloudEditorLspEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addPapiCredentialEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addPapiProxyEvent = function(_event, _content, _options) {
        };
        NoOpTrackerForLibrary2.prototype.addBootstrapEvent = function(_event, _content, _options) {
        };
        return NoOpTrackerForLibrary2;
      }()
    );
    exports.NoOpTrackerForLibrary = NoOpTrackerForLibrary;
  }
});

// node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/src/telemetry/TangerineBoxEventTrackerForWidget.js
var require_TangerineBoxEventTrackerForWidget = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/src/telemetry/TangerineBoxEventTrackerForWidget.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.NoOpTrackerForWidget = exports.TangerineBoxEventTrackerForWidget = void 0;
    var constants_1 = require_constants();
    var tangerinebox_weblib_core_1 = require_dist();
    var TangerineBoxEventTrackerForWidget = (
      /** @class */
      function() {
        function TangerineBoxEventTrackerForWidget2(scheduledEventTracker) {
          this.scheduledEventTracker = scheduledEventTracker;
        }
        TangerineBoxEventTrackerForWidget2.getInstance = function(trackerProps) {
          try {
            return new TangerineBoxEventTrackerForWidget2(tangerinebox_weblib_core_1.ScheduledEventTracker.getInstance(trackerProps));
          } catch (err) {
            console.warn(constants_1.TELEMETRY_CONFIG_MISSING_MSG);
            return new NoOpTrackerForWidget();
          }
        };
        TangerineBoxEventTrackerForWidget2.prototype.addEvent = function(content, options) {
          this.scheduledEventTracker.addEvent(content, options);
        };
        TangerineBoxEventTrackerForWidget2.prototype.addError = function(error, content, options) {
          this.scheduledEventTracker.addError(error, content, options);
        };
        TangerineBoxEventTrackerForWidget2.prototype.addFatalError = function(error, content, metadata, options) {
          this.scheduledEventTracker.addFatalError(error, content, metadata, options);
        };
        return TangerineBoxEventTrackerForWidget2;
      }()
    );
    exports.TangerineBoxEventTrackerForWidget = TangerineBoxEventTrackerForWidget;
    var NoOpTrackerForWidget = (
      /** @class */
      function() {
        function NoOpTrackerForWidget2() {
        }
        NoOpTrackerForWidget2.prototype.addEvent = function(_content, _options) {
        };
        NoOpTrackerForWidget2.prototype.addError = function(_error, _content, _options) {
        };
        NoOpTrackerForWidget2.prototype.addFatalError = function(_error, _content, _metadata, _options) {
        };
        return NoOpTrackerForWidget2;
      }()
    );
    exports.NoOpTrackerForWidget = NoOpTrackerForWidget;
  }
});

// node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/index.js
var require_dist2 = __commonJS({
  "node_modules/@amzn/tangerinebox-weblib-no-sdk/dist/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TangerineBoxEventTrackerForWidget = exports.TangerineBoxEventTrackerForLibrary = void 0;
    var TangerineBoxEventTrackerForLibrary_1 = require_TangerineBoxEventTrackerForLibrary();
    Object.defineProperty(exports, "TangerineBoxEventTrackerForLibrary", { enumerable: true, get: function() {
      return TangerineBoxEventTrackerForLibrary_1.TangerineBoxEventTrackerForLibrary;
    } });
    var TangerineBoxEventTrackerForWidget_1 = require_TangerineBoxEventTrackerForWidget();
    Object.defineProperty(exports, "TangerineBoxEventTrackerForWidget", { enumerable: true, get: function() {
      return TangerineBoxEventTrackerForWidget_1.TangerineBoxEventTrackerForWidget;
    } });
  }
});

// node_modules/@amzn/aws-console-lotus-data-plane-interface/dist/csp.js
var ExternalCspAssetName;
(function(ExternalCspAssetName2) {
  ExternalCspAssetName2["WebWorker"] = "worker.js";
  ExternalCspAssetName2["IFrame"] = "iFrame.html";
})(ExternalCspAssetName || (ExternalCspAssetName = {}));
var ErrorType;
(function(ErrorType3) {
  ErrorType3["FailedFetch"] = "FAILED_FETCH";
  ErrorType3["InvalidRequest"] = "INVALID_REQUEST";
  ErrorType3["FailedCsp"] = "FAILED_CSP";
})(ErrorType || (ErrorType = {}));

// node_modules/@amzn/aws-console-lotus-data-plane-interface/dist/metadata.js
var PackageMetadataRequestQueryParams;
(function(PackageMetadataRequestQueryParams2) {
  PackageMetadataRequestQueryParams2["PackageName"] = "packageName";
  PackageMetadataRequestQueryParams2["MajorVersion"] = "majorVersion";
  PackageMetadataRequestQueryParams2["AliasName"] = "aliasName";
  PackageMetadataRequestQueryParams2["AccountId"] = "accountId";
  PackageMetadataRequestQueryParams2["Region"] = "region";
  PackageMetadataRequestQueryParams2["CacheInvalidator"] = "cacheInvalidator";
  PackageMetadataRequestQueryParams2["SucceedOnRetry"] = "succeedOnRetry";
  PackageMetadataRequestQueryParams2["TrafficCategory"] = "trafficCategory";
})(PackageMetadataRequestQueryParams || (PackageMetadataRequestQueryParams = {}));

// node_modules/@amzn/aws-console-lotus-data-plane-interface/dist/isolatedIFrame.js
var IsolatedIFrameRequestQueryParams;
(function(IsolatedIFrameRequestQueryParams2) {
  IsolatedIFrameRequestQueryParams2["PackageName"] = "packageName";
  IsolatedIFrameRequestQueryParams2["MajorVersion"] = "majorVersion";
  IsolatedIFrameRequestQueryParams2["AliasName"] = "aliasName";
  IsolatedIFrameRequestQueryParams2["AccountId"] = "accountId";
  IsolatedIFrameRequestQueryParams2["SessionDifferentiator"] = "sessionDifferentiator";
  IsolatedIFrameRequestQueryParams2["ConsoleRegion"] = "consoleRegion";
  IsolatedIFrameRequestQueryParams2["UnifiedConsoleLoaderPackageName"] = "unifiedConsoleLoaderPackageName";
  IsolatedIFrameRequestQueryParams2["ParentOrigin"] = "parentOrigin";
  IsolatedIFrameRequestQueryParams2["LayoutBackgroundColorToken"] = "layoutBackgroundColorToken";
  IsolatedIFrameRequestQueryParams2["AwsUiVisualRefresh"] = "awsuiVisualRefresh";
  IsolatedIFrameRequestQueryParams2["Modal"] = "modal";
  IsolatedIFrameRequestQueryParams2["TrafficCategory"] = "trafficCategory";
})(IsolatedIFrameRequestQueryParams || (IsolatedIFrameRequestQueryParams = {}));

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/Logger.js
var import_tangerinebox_weblib_no_sdk = __toESM(require_dist2(), 1);

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/TelemetryTokenCreator.js
var TBT_SINK_TYPE = "DEFAULT_WIDGET_2023_04_19";
var TelemetryTokenCreator = class {
  /**
   * Generate a Telemetry token using Lotus package name by hashing service principal, telemetry sink name, and sink type values.
   */
  static async createTenantToken(packageName) {
    const { servicePrincipal, telemetrySinkName } = this.generateTangerineBoxTelemetryBoxTokenResources(packageName);
    const base = `${servicePrincipal}-${telemetrySinkName}-${TBT_SINK_TYPE}`;
    const hash = await this.hash(base);
    return `${this.getPrefix()}${hash}`;
  }
  static getPrefix() {
    return "v1/";
  }
  /**
   * Generate the recommended values to use for servicePrincipal and telemetrySinkName during creation of a
   * TangerineBox Telemetry Sink for a UCAF module or Standalone experience.
   * @param packageName Lotus package name
   * @returns servicePrincipal and telemetrySinkName
   */
  static generateTangerineBoxTelemetryBoxTokenResources(packageName) {
    const telemetrySinkName = packageName.replace("@amzn/", "").toLowerCase();
    const servicePrincipal = `prod.telemetry.${telemetrySinkName}.aws.internal`;
    return {
      servicePrincipal,
      telemetrySinkName
    };
  }
  static async hash(message) {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
    return hashHex;
  }
};

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/Logger.js
var AWT_TELEMETRY_SINK_ID = "v1/38ab1eac59303aa74f95dc67b661869747f928f1e58cde3ff57f15806b4db643";
var Logger = class {
  constructor() {
    __publicField(this, "startTime");
    /**
     * Get Elapsed Time
     * @returns {number}
     */
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    __publicField(this, "getElapsedTime", () => performance.now() - this.startTime);
  }
  /**
   * Initializes startTime which is used in getElapsedTime() to get elapsed time
   * @returns {number}
   */
  startTimer() {
    this.startTime = performance.now();
    return this.startTime;
  }
  /**
   * @returns TBT Event Tracker for lotus internal account, lotus package producer, and consumer logs
   */
  async getTBTEventTracker({ packageName, telemetryToken, parentTelemetryTokens = [] }) {
    const lotusPackageProducerToken = telemetryToken || await TelemetryTokenCreator.createTenantToken(packageName);
    const tokensForPublicEvents = [lotusPackageProducerToken, ...parentTelemetryTokens];
    return import_tangerinebox_weblib_no_sdk.TangerineBoxEventTrackerForLibrary.getInstance({
      token: AWT_TELEMETRY_SINK_ID,
      tokensForPublicEvents
    });
  }
};

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/__generated__/region-partition-map.js
var regionPartitionMap = { "us-isof-south-1": "aws-iso-f", "us-iso-west-1": "aws-iso", "cn-north-1": "aws-cn", "us-iso-east-1": "aws-iso", "us-isob-west-1": "aws-iso-b", "us-isob-east-1": "aws-iso-b", "us-isof-east-1": "aws-iso-f", "eu-isoe-west-1": "aws-iso-e", "us-gov-east-1": "aws-us-gov", "us-gov-west-1": "aws-us-gov", "cn-northwest-1": "aws-cn" };

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/console-partition-info.js
var Partition;
(function(Partition2) {
  Partition2["Aws"] = "aws";
  Partition2["AwsCn"] = "aws-cn";
  Partition2["AwsUsGov"] = "aws-us-gov";
  Partition2["AwsIso"] = "aws-iso";
  Partition2["AwsIsoB"] = "aws-iso-b";
  Partition2["AwsIsoE"] = "aws-iso-e";
  Partition2["AwsIsoF"] = "aws-iso-f";
})(Partition || (Partition = {}));
var PARTITION_INFO = {
  [Partition.Aws]: {
    rootDomain: "amazon.com",
    defaultRegion: "us-east-1",
    regionlessSubDomain: "console.aws",
    globalSubDomain: "global.console.aws",
    dualstackRootDomain: "aws.com",
    // eslint-disable-next-line @amzn/awt-build-tools-internal/no-restricted-terms
    dualstackGlobalSubDomain: "lotus.widget.console"
  },
  [Partition.AwsCn]: {
    rootDomain: "amazonaws.cn",
    defaultRegion: "cn-north-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "amazonwebservices.cn"
  },
  [Partition.AwsUsGov]: {
    rootDomain: "amazonaws-us-gov.com",
    defaultRegion: "us-gov-west-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "aws-us-gov.com"
  },
  [Partition.AwsIso]: {
    rootDomain: "c2shome.ic.gov",
    defaultRegion: "us-iso-east-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.ic.gov"
  },
  [Partition.AwsIsoB]: {
    rootDomain: "sc2shome.sgov.gov",
    defaultRegion: "us-isob-east-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.scloud"
  },
  [Partition.AwsIsoE]: {
    rootDomain: "csphome.adc-e.uk",
    defaultRegion: "eu-isoe-west-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.adc-e.uk"
  },
  [Partition.AwsIsoF]: {
    rootDomain: "csphome.hci.ic.gov",
    defaultRegion: "us-isof-south-1",
    regionlessSubDomain: "console",
    dualstackRootDomain: "awshome.hci.ic.gov"
  }
};
var AWSC_MEZZ_REGION_ID = "awsc-mezz-region";
function getCurrentRegion() {
  const mezzRegionElement = document.getElementById(AWSC_MEZZ_REGION_ID);
  let region = mezzRegionElement == null ? void 0 : mezzRegionElement.getAttribute("content");
  if (!mezzRegionElement) {
    try {
      const topWindowMezzRegionElement = window.top.document.getElementById(AWSC_MEZZ_REGION_ID);
      region = topWindowMezzRegionElement == null ? void 0 : topWindowMezzRegionElement.getAttribute("content");
    } catch {
    }
  }
  if (region) {
    return region;
  }
  console.warn("Lotus: awsc-mezz-region element is not available. Falling back to default region");
  for (const partitionInfo of Object.values(PARTITION_INFO)) {
    if (window.location.host.includes(partitionInfo.rootDomain)) {
      return partitionInfo.defaultRegion;
    }
  }
  return "us-east-1";
}
function getLotusHost(region) {
  const partition = regionPartitionMap[region] || Partition.Aws;
  const partitionInfo = PARTITION_INFO[partition];
  if (partitionInfo.globalSubDomain) {
    return `${PARTITION_INFO[partition].globalSubDomain}.${PARTITION_INFO[partition].rootDomain}`;
  }
  return `${region}.${PARTITION_INFO[partition].regionlessSubDomain}.${PARTITION_INFO[partition].rootDomain}`;
}
function getLotusDualstackHost(region) {
  const partition = regionPartitionMap[region] || Partition.Aws;
  const partitionInfo = PARTITION_INFO[partition];
  if (partitionInfo.dualstackGlobalSubDomain) {
    return `${PARTITION_INFO[partition].dualstackGlobalSubDomain}.${PARTITION_INFO[partition].dualstackRootDomain}`;
  }
  return `${region}.${PARTITION_INFO[partition].regionlessSubDomain}.${PARTITION_INFO[partition].dualstackRootDomain}`;
}

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/utils/retry-utils.js
var exponentialBackoff = (attemptIndex, delayInMs) => {
  const delay = Math.random() * 2 ** attemptIndex * delayInMs;
  return new Promise((resolve) => setTimeout(resolve, delay));
};

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/import-package/utils/html-utils.js
var HtmlTag = {
  Script: "script",
  Link: "link"
};
var TagAppendLocation = {
  [HtmlTag.Link]: "head",
  [HtmlTag.Script]: "body"
};

// node_modules/@amzn/awsconsole-web-utils/dist/internal/cookieUtils.js
var parseCookiesString = (cookieString) => {
  const allCookies = document.cookie.length > 0 ? cookieString.split(";") : [];
  const len = allCookies.length;
  const parsedCookiesMap = {};
  for (let i = 0; i < len; i++) {
    const cookieParts = allCookies[i].split("=");
    const cookieName = cookieParts[0].trim();
    const cookieValue = cookieParts[1];
    parsedCookiesMap[cookieName] = { raw: cookieValue };
  }
  return {
    getCookie: (cookieName) => {
      const entry = parsedCookiesMap[cookieName];
      if (!entry) {
        return null;
      }
      let unescapedValue = entry.unescaped;
      if (unescapedValue === void 0) {
        const rawValue = entry.raw;
        unescapedValue = entry.unescaped = unescape(rawValue.trim());
      }
      return unescapedValue;
    }
  };
};
var getCookie = (cookieName) => {
  const cookiesString = document.cookie;
  const parsedCookies = parseCookiesString(cookiesString);
  return parsedCookies.getCookie(cookieName);
};
var cachedValues = {};
var getCookieCached = (cookieName) => {
  let cachedValue = cachedValues[cookieName];
  if (cachedValue === void 0) {
    cachedValue = cachedValues[cookieName] = getCookie(cookieName) || null;
  }
  return cachedValue;
};

// node_modules/@amzn/awsconsole-web-utils/dist/internal/metaTagParser.js
function getMetaTagContent(metaTagName) {
  var _a;
  try {
    const selector = `meta[name='${metaTagName}']`;
    let element = document.querySelector(selector);
    if (!element) {
      element = (_a = window.top) == null ? void 0 : _a.document.querySelector(selector);
    }
    return element == null ? void 0 : element.content;
  } catch (e) {
    return void 0;
  }
}
function parseMetaTag(metaTagName) {
  const content = getMetaTagContent(metaTagName);
  if (content) {
    return JSON.parse(content);
  } else {
    throw new Error(`failed to parse meta tag ${metaTagName}`);
  }
}

// node_modules/@amzn/awsconsole-web-utils/dist/content/regions.js
var regions_default = {
  "regions": {
    "ap-southeast-6": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-isof-south-1": {
      "websiteDomain": "csphome.hci.ic.gov",
      "websiteDomainDualstack": "awshome.hci.ic.gov"
    },
    "us-iso-west-1": {
      "websiteDomain": "c2shome.ic.gov",
      "websiteDomainDualstack": "awshome.ic.gov"
    },
    "eu-north-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "me-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "cn-north-1": {
      "websiteDomain": "amazonaws.cn",
      "websiteDomainDualstack": "amazonwebservices.cn"
    },
    "ap-southeast-7": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "eu-west-3": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-southeast-3": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-east-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "af-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-iso-east-1": {
      "websiteDomain": "c2shome.ic.gov",
      "websiteDomainDualstack": "awshome.ic.gov"
    },
    "eu-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "me-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-isob-west-1": {
      "websiteDomain": "sc2shome.sgov.gov",
      "websiteDomainDualstack": "awshome.scloud"
    },
    "eu-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "sa-east-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-east-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-south-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-east-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-northeast-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-northeast-3": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-southeast-5": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-isob-east-1": {
      "websiteDomain": "sc2shome.sgov.gov",
      "websiteDomainDualstack": "awshome.scloud"
    },
    "eu-west-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-isof-east-1": {
      "websiteDomain": "csphome.hci.ic.gov",
      "websiteDomainDualstack": "awshome.hci.ic.gov"
    },
    "us-northeast-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-southeast-4": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "eu-south-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "eu-isoe-west-1": {
      "websiteDomain": "csphome.adc-e.uk",
      "websiteDomainDualstack": "awshome.adc-e.uk"
    },
    "ap-northeast-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-gov-east-1": {
      "websiteDomain": "amazonaws-us-gov.com",
      "websiteDomainDualstack": "aws-us-gov.com"
    },
    "us-gov-west-1": {
      "websiteDomain": "amazonaws-us-gov.com",
      "websiteDomainDualstack": "aws-us-gov.com"
    },
    "us-west-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "mx-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "me-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "us-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-southeast-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-southeast-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "eusc-de-east-1": {
      "websiteDomain": "amazonaws-eusc.eu",
      "websiteDomainDualstack": "aws.eu"
    },
    "il-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ap-east-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ca-central-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "ca-west-1": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "eu-south-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    },
    "cn-northwest-1": {
      "websiteDomain": "amazonaws.cn",
      "websiteDomainDualstack": "amazonwebservices.cn"
    },
    "eu-central-2": {
      "websiteDomain": "aws.amazon.com",
      "websiteDomainDualstack": "aws.com"
    }
  }
};

// node_modules/@amzn/awsconsole-web-utils/dist/sessionDataProvider/sessionDataParser.js
var SESSION_DATA_NAME_ATTRIBUTE = "awsc-session-data";
var MEZZ_REGION_NAME_ATTRIBUTE = "awsc-mezz-region";
var sessionDataTemplate = {
  accountId: void 0,
  sessionARN: void 0,
  sessionId: void 0,
  sessionDifferentiator: void 0,
  identityToken: void 0,
  accountAlias: void 0,
  displayName: void 0,
  infrastructureRegion: void 0,
  vpc: {
    vpcId: void 0,
    vpceId: void 0
  },
  prismModeEnabled: void 0,
  dualstackEnabledDomain: void 0,
  websiteDomainDualstack: void 0
};
function validateSessionDataFields(data, fields) {
  if (!data) {
    throw new Error("SessionData object is null or undefined");
  }
  const missingFieldsInSessionData = [];
  fields.forEach((sessionDataField) => {
    if (sessionDataField === "sessionDifferentiator" && !data.prismModeEnabled) {
      return;
    }
    if (sessionDataField === "websiteDomainDualstack" && !data.dualstackEnabledDomain) {
      return;
    }
    if (data[sessionDataField] == null) {
      missingFieldsInSessionData.push(sessionDataField);
    }
  });
  if (missingFieldsInSessionData.length) {
    const message = JSON.stringify({ missingFieldsInSessionData });
    throw new Error(message);
  }
  return true;
}
var _SessionDataParser = class _SessionDataParser {
  constructor() {
    __publicField(this, "sessionDataCache");
    this.sessionDataCache = this.parseSessionDataMetaTag();
  }
  /*
   * Return SessionDataProvider instance for singleton class.
   */
  static getInstance() {
    if (!this.sessionDataParserInstance) {
      this.sessionDataParserInstance = new _SessionDataParser();
    }
    return this.sessionDataParserInstance;
  }
  /**
   * Validate an object to see if it contains the required keys for session data
   *
   * @param {any} data - an object that needs to be validated
   * @throws
   * @returns void
   */
  static validateSessionData(data) {
    validateSessionDataFields(data, [
      "sessionARN",
      "identityToken",
      "accountId",
      "infrastructureRegion",
      "sessionDifferentiator",
      "dualstackEnabledDomain",
      "websiteDomainDualstack"
    ]);
  }
  /**
   * Validate the session data in {@link SessionDataParser}
   *
   * @throws
   * @returns void
   */
  validateSessionData() {
    _SessionDataParser.validateSessionData(this.sessionDataCache);
  }
  getSessionData() {
    if (this.sessionDataCache) {
      return this.sessionDataCache;
    }
    return this.parseSessionDataMetaTag();
  }
  parseSessionDataMetaTag() {
    let sessionData;
    let legacySessionData;
    try {
      sessionData = parseMetaTag(SESSION_DATA_NAME_ATTRIBUTE);
      if (!validateSessionDataFields(sessionData, [
        "sessionARN",
        "identityToken",
        "accountId",
        "infrastructureRegion",
        "sessionDifferentiator"
      ])) {
        legacySessionData = this.parseSessionDataLegacy();
      }
    } catch (error) {
      console.log(error);
      try {
        legacySessionData = this.parseSessionDataLegacy();
      } catch (e) {
      }
    }
    const region = (sessionData == null ? void 0 : sessionData.infrastructureRegion) || (legacySessionData == null ? void 0 : legacySessionData.infrastructureRegion);
    return {
      ...sessionDataTemplate,
      // ensure that all fields from session data template are returned, even if undefined
      // resolve missing session data fields (if any) from legacy session data
      ...this.getDualstackDomainData(region),
      ...legacySessionData,
      ...sessionData
    };
  }
  decryptUserInfoSignedCookie(userinfoSignedValue) {
    try {
      const encodedUserInfoValue = userinfoSignedValue.split(".")[1];
      const decodedUserInfoValue = atob(encodedUserInfoValue);
      return JSON.parse(decodedUserInfoValue);
    } catch (e) {
      console.warn("Unable to decrypt userInfoSigned cookie");
      return "";
    }
  }
  getSessionDataFromUserInfoCookie() {
    var _a, _b;
    const cookieValue = getCookieCached("aws-userInfo");
    const cookieValueUserinfoSigned = getCookieCached("aws-userInfo-signed");
    const ARN_REGEX = /arn:([^:]*):([^:]*):([^:]*):([^:]*):([^:]*)/;
    if (cookieValue && cookieValueUserinfoSigned) {
      const { arn, alias, username } = JSON.parse(cookieValue);
      const match = ARN_REGEX.exec(arn);
      return {
        accountId: match ? match[4] : "",
        sessionARN: arn,
        accountAlias: alias,
        displayName: username,
        identityToken: cookieValueUserinfoSigned,
        sessionDifferentiator: (_b = (_a = this.decryptUserInfoSignedCookie(cookieValueUserinfoSigned)) == null ? void 0 : _a.sessionDiff) != null ? _b : void 0
      };
    }
    throw new Error("No userinfo or userinfo-signed cookie found!");
  }
  getInfrastructureRegionFromMezzanineMetaTag() {
    return getMetaTagContent(MEZZ_REGION_NAME_ATTRIBUTE);
  }
  parseSessionDataLegacy() {
    try {
      return {
        ...this.getSessionDataFromUserInfoCookie(),
        infrastructureRegion: this.getInfrastructureRegionFromMezzanineMetaTag()
      };
    } catch (error) {
      console.warn("Unable to parse the data using legacy methods");
      throw error;
    }
  }
  getDualstackDomainData(region) {
    const ultimateFallbackData = {
      dualstackEnabledDomain: void 0,
      websiteDomainDualstack: void 0
    };
    if (!region || !Object.keys(regions_default.regions).includes(region)) {
      console.error("Couldn't determine console domain and dual-stack values.");
      return ultimateFallbackData;
    }
    const ripRegion = regions_default.regions[region];
    const { websiteDomain, websiteDomainDualstack } = ripRegion;
    const { hostname } = window.location;
    if (!websiteDomainDualstack) {
      return {
        dualstackEnabledDomain: false,
        websiteDomainDualstack: websiteDomain
      };
    }
    let dualstackEnabledDomain;
    if (hostname.endsWith(`.${websiteDomainDualstack}`)) {
      dualstackEnabledDomain = true;
    } else if (hostname.endsWith(`.${websiteDomain}`)) {
      dualstackEnabledDomain = false;
    }
    return {
      dualstackEnabledDomain,
      websiteDomainDualstack: dualstackEnabledDomain ? websiteDomainDualstack : void 0
    };
  }
};
__publicField(_SessionDataParser, "sessionDataParserInstance");
var SessionDataParser = _SessionDataParser;

// node_modules/@amzn/awsconsole-web-utils/dist/prism/index.js
var isUserOptedIntoPrism = () => {
  const PRISM_OPT_IN_COOKIE = "aws-prism-opt-in";
  const isOptedIntoPrism = getCookie(PRISM_OPT_IN_COOKIE) || "";
  return !!isOptedIntoPrism && isOptedIntoPrism === "true";
};

// node_modules/@amzn/awsconsole-web-utils/dist/sessionDataProvider/index.js
var _SessionDataProvider = class _SessionDataProvider {
  constructor(instance) {
    __publicField(this, "dataParser");
    this.dataParser = instance;
  }
  /*
   * Return SessionDataProvider instance for singleton class.
   */
  static getInstance() {
    if (!this.sessionDataProviderInstance) {
      this.sessionDataProviderInstance = new _SessionDataProvider(SessionDataParser.getInstance());
    }
    return this.sessionDataProviderInstance;
  }
  /**
   * @returns sessionARN: Promise<string>
   * returns empty string when falsy
   */
  async getSessionARN() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionARN"] || "";
  }
  /**
   * @returns accountId: Promise<string>
   * returns empty string when falsy
   */
  async getAccountId() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["accountId"] || "";
  }
  /**
   * @returns identityToken: Promise<string>
   * returns empty string when falsy
   */
  async getIdentityToken() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["identityToken"] || "";
  }
  /**
   * @returns sessionId: Promise<string | undefined>
   */
  async getSessionId() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionId"];
  }
  /**
   * This method provides the region the page is served from.
   * returns empty string when falsy
   * @returns region: Promise<string>
   */
  async getInfrastructureRegion() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["infrastructureRegion"] || "";
  }
  /**
   * This method provides the VPC if it exists.
   *
   * @returns vpc: Promise<VPC | undefined>
   */
  async getVpc() {
    const sessionData = this.dataParser.getSessionData();
    let result;
    if (sessionData) {
      result = sessionData["vpc"];
    }
    return result;
  }
  /**
   * This method provides the accountAlias if it exists.
   *
   * @returns accountAlias: Promise<string | undefined>
   */
  async getAccountAlias() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["accountAlias"];
  }
  /**
   * This method provides the displayName if it exists.
   *
   * @returns displayName: Promise<string | undefined>
   */
  async getDisplayName() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["displayName"];
  }
  /**
   * This method provides the sessionDifferentiator if it exists.
   *
   * @returns sessionDifferentiator: Promise<string | undefined>
   */
  async getSessionDifferentiator() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionDifferentiator"];
  }
  /**
   * This method provides an object with current session information and some of the fields are optional
   * and may not be always present. If you only care about getting individual properties, use the respective function such as
   * getAccountId
   * @returns SessionData
   */
  async getSessionData() {
    const sessionData = this.dataParser.getSessionData();
    if (!sessionData["prismModeEnabled"]) {
      sessionData.prismModeEnabled = isUserOptedIntoPrism();
    }
    return sessionData;
  }
  /**
   * This method provides the state of prismModeEnabled if it exists
   *
   * @returns isMultiSessionEnabled: Promise<boolean | undefined>
   */
  async isMultiSessionEnabled() {
    const sessionData = this.dataParser.getSessionData();
    if (!sessionData["prismModeEnabled"]) {
      return isUserOptedIntoPrism();
    }
    return sessionData["prismModeEnabled"];
  }
};
__publicField(_SessionDataProvider, "sessionDataProviderInstance");
/**
 * Validate an object to see if it contains the required keys for session data
 *
 * @param {any} maybeSessionData - an object that needs to be validated
 * @returns {boolean} if the session data object passed in was valid
 */
__publicField(_SessionDataProvider, "isValidSessionData", (maybeSessionData) => {
  try {
    SessionDataParser.validateSessionData(maybeSessionData);
    return true;
  } catch (err) {
    return false;
  }
});
/**
 * Validate an object to see if it contains the required keys for session data, throw error if invalid
 *
 * @param {any} maybeSessionData - an object that needs to be validated
 * @returns {boolean} true if the session data object passed in was valid, throws error if invalid
 */
__publicField(_SessionDataProvider, "validateSessionData", (maybeSessionData) => {
  SessionDataParser.validateSessionData(maybeSessionData);
  return true;
});
var SessionDataProvider = _SessionDataProvider;

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/logger.js
var MetadataLogger = class extends Logger {
  /**
   * log multiple metrics from a finished request.
   * @param {string} packageName
   * @param {string} majorVersion
   * @param {number} statusCode
   * @param {number} elapsedTime
   * @param {Error} error - Optional
   * @param {ResponseHeaders} responseHeaders - Optional
   * @param {string} versionId - Optional
   * @param {string} telemetryToken - Optional
   * @param {string} parentTelemetryTokens - Optional
   */
  async logRequest(props) {
    await this.emitTBTMetric(props);
  }
  // Emit TBT logs to package producer and consumer accounts (if parentConsole TBT token given) and lotus internal accounts.
  async emitTBTMetric({ packageName, majorVersion, elapsedTime, statusCode, error, responseHeaders, versionId, telemetryToken, parentTelemetryTokens }) {
    const tbtEventTracker = await this.getTBTEventTracker({
      packageName,
      telemetryToken,
      parentTelemetryTokens
    });
    tbtEventTracker.addLotusImportPackageEvent({
      lotusMetadata: {
        packageName,
        majorVersion,
        versionId,
        latency: elapsedTime,
        statusCode,
        requestId: responseHeaders ? responseHeaders.apiGatewayRequestId : void 0,
        errorDetails: error ? { code: error.name, message: error.message } : void 0
      }
    }, void 0, { publicEvent: true });
  }
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/types.js
var SigninStage;
(function(SigninStage2) {
  SigninStage2["PROD"] = "prod";
  SigninStage2["PRODISH"] = "prodish";
})(SigninStage || (SigninStage = {}));
var AccessType;
(function(AccessType2) {
  AccessType2["AnyAccount"] = "ANY_ACCOUNT";
  AccessType2["AllowedAccounts"] = "ALLOWED_ACCOUNTS";
})(AccessType || (AccessType = {}));
var LotusMetadataClientError = class extends Error {
  constructor({ name, message, cause, status }) {
    super(message, cause);
    __publicField(this, "status");
    this.status = status;
    this.name = name;
  }
};
var ErrorType2;
(function(ErrorType3) {
  ErrorType3["NetworkError"] = "NetworkError";
  ErrorType3["InvalidParametersError"] = "InvalidParametersError";
  ErrorType3["InvalidResponseError"] = "InvalidResponseError";
  ErrorType3["ConsoleProxyWafError"] = "ConsoleProxyWAFError";
})(ErrorType2 || (ErrorType2 = {}));

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/util.js
var LOTUS_METADATA_PATH = "/lotus/metadata";
var getCookie2 = (cookieName) => {
  const cookie = Object.fromEntries(document.cookie.split(";").map((cookieDefinition) => cookieDefinition.split("=").map((data) => decodeURIComponent(data.trim()))));
  return cookie[cookieName];
};
var isValidMetadataStructure = (response) => {
  var _a, _b, _c;
  return !!((response == null ? void 0 : response.basePath) && (response == null ? void 0 : response.versionId) && (((_a = response == null ? void 0 : response.metadata) == null ? void 0 : _a.module) || ((_c = (_b = response == null ? void 0 : response.metadata) == null ? void 0 : _b.assets) == null ? void 0 : _c.length)));
};
var getRegionInIsolatedIframe = () => {
  const searchParams = new URLSearchParams(location.search);
  const region = searchParams.get(IsolatedIFrameRequestQueryParams.ConsoleRegion);
  if (!region) {
    return void 0;
  }
  return region;
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/request-helper.js
var REQUEST_TIMEOUT = 1e4;
var CANARY_REQUEST_TIMEOUT = 5e3;
var MAX_TRIES = 4;
var RETRY_DELAY = 100;
var unretryableStatusCodes = /* @__PURE__ */ new Set([400, 401, 403, 404, 413, 415]);
var APIGW_V1_REQUEST_ID_RESP_HEADER = "X-Amz-Apigw-Id";
var APIGW_V2_REQUEST_ID_RESP_HEADER = "Apigw-Requestid";
var LOTUS_REGION_RESP_HEADER = "x-lotus-region";
var sendHttpGetRequest = async (url, headers, timeout) => {
  const controller = new AbortController();
  setTimeout(() => {
    controller.abort();
  }, timeout);
  const requestInit = {
    method: "GET",
    headers,
    credentials: "omit",
    signal: controller.signal
  };
  try {
    const fetchResponse = await fetch(url, requestInit);
    return {
      status: fetchResponse.status,
      body: await fetchResponse.text(),
      responseHeaders: {
        apiGatewayRequestId: fetchResponse.headers.get(APIGW_V2_REQUEST_ID_RESP_HEADER) || fetchResponse.headers.get(APIGW_V1_REQUEST_ID_RESP_HEADER) || "null",
        lotusRegion: fetchResponse.headers.get(LOTUS_REGION_RESP_HEADER) || "null"
      }
    };
  } catch (error) {
    throw new LotusMetadataClientError({
      name: ErrorType2.NetworkError,
      message: error.name === "AbortError" ? "Timed out" : `Fetch error: ${error.message}`,
      cause: error
    });
  }
};
var sendHttpGetRequestWithRetries = async (url, headers, requestConfig) => {
  const isCanary = getCookie2("metrics-req-cat") === "canary";
  const tries = (requestConfig == null ? void 0 : requestConfig.tries) || MAX_TRIES;
  const retryDelay = (requestConfig == null ? void 0 : requestConfig.retryDelay) || RETRY_DELAY;
  const timeout = (requestConfig == null ? void 0 : requestConfig.timeout) || (isCanary ? CANARY_REQUEST_TIMEOUT : REQUEST_TIMEOUT);
  let latestError = new Error("Error");
  let latestResponse;
  for (let attemptIndex = 0; attemptIndex < tries; attemptIndex += 1) {
    try {
      latestResponse = await sendHttpGetRequest(url, headers, timeout);
      if (latestResponse.status === 200) {
        break;
      }
      if (unretryableStatusCodes.has(latestResponse.status)) {
        break;
      }
    } catch (error) {
      latestError = error;
      if (error.name !== ErrorType2.NetworkError) {
        break;
      }
    }
    await exponentialBackoff(attemptIndex, retryDelay);
  }
  if (latestResponse !== void 0) {
    return latestResponse;
  }
  throw latestError;
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/tangerine-box/errors.js
var TangerineBoxError = class extends Error {
  constructor(message, originalError) {
    super(message);
    __publicField(this, "message");
    __publicField(this, "originalError");
    this.message = message;
    this.originalError = originalError;
    this.name = this.constructor.name;
    if (originalError) {
      this.stack += `
Caused by: ${originalError.stack}`;
    }
  }
};
var MetaTagParsingError = class extends TangerineBoxError {
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/tangerine-box/meta-tag.js
function parseMetaTag2(metaTagName) {
  const element = document.querySelector(`meta[name='${metaTagName}']`);
  if (!element) {
    return void 0;
  }
  return element.content;
}
function parseTangerineBoxMetaTag() {
  const element = parseMetaTag2("tb-data");
  if (!element) {
    throw new MetaTagParsingError("TangerineBox meta tag not found");
  }
  try {
    return JSON.parse(element);
  } catch (error) {
    throw new MetaTagParsingError("Unable to parse TangerineBox meta tag contents", error instanceof Error ? error : new Error(String(error)));
  }
}

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/tangerine-box/index.js
var metaTagContentCache;
var TangerineBox = class {
  constructor(metaTagContent) {
    if (metaTagContent) {
      metaTagContentCache = metaTagContent;
    }
  }
  /**
   * Returns the base URL for a given asset ID
   *
   * @see https://quip-amazon.com/xBRHARHS2ZZb/Documentation-04-Building-a-web-application#cDO9CAtNqxS
   */
  getCdnUrl(assetId) {
    if (/^(http|https|ws|wss):\/\//.test(assetId)) {
      return assetId;
    }
    return `${this.getMetaTagContent().cdn}${assetId}`;
  }
  /** Returns parsed content of tb-data meta tag */
  getMetaTagContent() {
    if (!metaTagContentCache) {
      metaTagContentCache = parseTangerineBoxMetaTag();
    }
    return metaTagContentCache;
  }
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/package-metadata/metadata.js
function parseAndValidateMetadataHttpResponse({ status, parsedBody }) {
  if (status < 200 || status >= 300) {
    const { code, message } = parsedBody;
    throw new LotusMetadataClientError({
      name: code || ErrorType2.InvalidResponseError,
      message,
      status
    });
  }
  if (!isValidMetadataStructure(parsedBody)) {
    throw new LotusMetadataClientError({
      name: ErrorType2.InvalidResponseError,
      message: "Invalid metadata structure in response body",
      status
    });
  }
  const lotusCDNUrl = new URL(parsedBody.basePath);
  try {
    const tangerinebox = new TangerineBox();
    const tbCDNUrlString = tangerinebox.getCdnUrl("");
    const tbCDNUrl = new URL(tbCDNUrlString);
    lotusCDNUrl.hostname = tbCDNUrl.hostname;
    parsedBody.basePath = lotusCDNUrl.toString();
  } catch {
  }
  return parsedBody;
}
function parseHttpResponse({ status, body }) {
  let parsedBody;
  try {
    parsedBody = JSON.parse(body);
  } catch (error) {
    if (status === 405) {
      throw new LotusMetadataClientError({
        name: ErrorType2.ConsoleProxyWafError,
        message: `Received 405 from Console Proxy WAF: ${body}`
      });
    }
    throw new LotusMetadataClientError({
      name: ErrorType2.InvalidResponseError,
      message: `Response body is not valid JSON: ${body}`,
      cause: error,
      status
    });
  }
  return parsedBody;
}
var getPackageMetadata = async ({ packageName, majorVersion, host, aliasName, accessType, consoleRegion, onComplete, cacheInvalidator, telemetryToken, parentTelemetryTokens }) => {
  var _a;
  const startTime = performance.now();
  const onCompleteFunction = onComplete != null ? onComplete : (metrics) => {
    new MetadataLogger().logRequest(metrics);
  };
  let httpGetResponse;
  let telemetryTokenPromise = Promise.resolve(void 0);
  let resolvedTelemetryToken;
  try {
    if (!packageName || !majorVersion) {
      throw new LotusMetadataClientError({
        name: ErrorType2.InvalidParametersError,
        message: "Missing package name or majorVersion."
      });
    }
    if (typeof telemetryToken === "string") {
      telemetryTokenPromise = Promise.resolve(telemetryToken);
    }
    if (typeof telemetryToken === "function") {
      telemetryTokenPromise = telemetryToken();
    }
    const metadataProvider = SessionDataProvider.getInstance();
    const accountId = await metadataProvider.getAccountId();
    const currentRegion = consoleRegion || await metadataProvider.getInfrastructureRegion() || getRegionInIsolatedIframe() || getCurrentRegion();
    if (!accountId || !currentRegion) {
      throw new LotusMetadataClientError({
        name: ErrorType2.InvalidParametersError,
        message: "Missing accountId or console region."
      });
    }
    let headers = {};
    const searchParams = new URLSearchParams({
      [PackageMetadataRequestQueryParams.PackageName]: packageName,
      [PackageMetadataRequestQueryParams.MajorVersion]: majorVersion,
      [PackageMetadataRequestQueryParams.AccountId]: accountId,
      [PackageMetadataRequestQueryParams.Region]: currentRegion,
      [PackageMetadataRequestQueryParams.SucceedOnRetry]: "true"
    });
    if (aliasName) {
      searchParams.append(PackageMetadataRequestQueryParams.AliasName, aliasName);
    }
    if (cacheInvalidator) {
      searchParams.append(PackageMetadataRequestQueryParams.CacheInvalidator, cacheInvalidator);
    }
    const testTrafficCookieValue = getCookie2("metrics-req-cat");
    if (testTrafficCookieValue) {
      searchParams.append(PackageMetadataRequestQueryParams.TrafficCategory, testTrafficCookieValue);
    }
    let lotusHost = getLotusHost(currentRegion);
    const sessionData = await metadataProvider.getSessionData();
    if (sessionData == null ? void 0 : sessionData.dualstackEnabledDomain) {
      lotusHost = getLotusDualstackHost(currentRegion);
    }
    const packageMetadataApiUrl = `https://${host || lotusHost}${LOTUS_METADATA_PATH}?${searchParams.toString()}`;
    const missingIdentityTokenError = new LotusMetadataClientError({
      name: ErrorType2.InvalidParametersError,
      message: "Missing identity token."
    });
    if (accessType === AccessType.AllowedAccounts) {
      const identityToken = await metadataProvider.getIdentityToken();
      if (!identityToken) {
        throw missingIdentityTokenError;
      }
      headers = {
        "x-userinfo-signed": identityToken
      };
    }
    httpGetResponse = await sendHttpGetRequestWithRetries(packageMetadataApiUrl, headers);
    let responseBody = parseHttpResponse(httpGetResponse);
    if (responseBody.retryWithIdentityToken) {
      const identityToken = await metadataProvider.getIdentityToken();
      if (!identityToken) {
        throw missingIdentityTokenError;
      }
      headers = {
        "x-userinfo-signed": identityToken
      };
      httpGetResponse = await sendHttpGetRequestWithRetries(packageMetadataApiUrl, headers);
      responseBody = parseHttpResponse(httpGetResponse);
    }
    const packageMetadataResponse = parseAndValidateMetadataHttpResponse({
      status: httpGetResponse.status,
      parsedBody: responseBody
    });
    resolvedTelemetryToken = (_a = packageMetadataResponse.telemetryToken) != null ? _a : await telemetryTokenPromise;
    onCompleteFunction({
      packageName,
      majorVersion,
      elapsedTime: performance.now() - startTime,
      statusCode: 200,
      responseHeaders: httpGetResponse.responseHeaders,
      versionId: packageMetadataResponse.versionId,
      telemetryToken: resolvedTelemetryToken,
      parentTelemetryTokens
    });
    return packageMetadataResponse;
  } catch (error) {
    onCompleteFunction({
      packageName,
      majorVersion,
      elapsedTime: performance.now() - startTime,
      error,
      statusCode: httpGetResponse ? httpGetResponse.status : void 0,
      responseHeaders: httpGetResponse ? httpGetResponse.responseHeaders : void 0,
      versionId: void 0,
      telemetryToken: resolvedTelemetryToken,
      parentTelemetryTokens
    });
    throw error;
  }
};

// src/vendor/index.js
var import_tangerinebox_weblib_no_sdk2 = __toESM(require_dist2());
var export_TangerineBoxEventTrackerForLibrary = import_tangerinebox_weblib_no_sdk2.TangerineBoxEventTrackerForLibrary;
export {
  export_TangerineBoxEventTrackerForLibrary as TangerineBoxEventTrackerForLibrary,
  getPackageMetadata
};
